export enum TOOLBAR_TYPE {
  inline = 'inline',
  list = 'list',
  advanced = 'advanced',
}

export default [
  {
    type: TOOLBAR_TYPE.inline,
    style: 'BOLD',
    icon: 'bold',
    label: 'bold',
  },
  {
    type: TOOLBAR_TYPE.inline,
    style: 'UNDERLINE',
    icon: 'underline',
    label: 'underline',
  },
  {
    type: TOOLBAR_TYPE.inline,
    style: 'ITALIC',
    icon: 'italic',
    label: 'italic',
  },
  {
    type: TOOLBAR_TYPE.list,
    block: 'unordered-list-item',
    icon: 'list-ul',
    label: 'unordered list',
  },
  {
    type: TOOLBAR_TYPE.list,
    block: 'ordered-list-item',
    icon: 'list-ol',
    label: 'ordered list',
  },
  {
    type: TOOLBAR_TYPE.advanced,
    block: 'emoji',
    icon: 'smile',
    label: 'emoji',
  },
  {
    type: TOOLBAR_TYPE.advanced,
    block: 'gif',
    icon: 'gif',
    iconPrefix: 'fac',
    label: 'gif',
  },
];
